module.exports = __webpack_public_path__ + "img/ico_delivery_sort_bulk.5a26457.png";